module.exports = __webpack_public_path__ + "static/media/logo.36dc54f0.svg";